// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from 'react'
// import styles from './BackNextButtons.module.scss'
// import { useHistory } from 'react-router-dom'

// const BackNextButtons = ({ props, nextOnClick, displayBack = true }) => {
//   const history = useHistory()
//   return (
//     <div className={styles['display_flex']}>
//       {displayBack ? (
//         <div className={styles['back_center']}>
//           <a
//             onClick={() => {
//               try {
//                 history.push(props.prevURL)
//               } catch (e) {
//                 console.log(e)
//               }
//             }}
//             href={props.prevURL}
//           >
//             {props.prevText}
//           </a>
//         </div>
//       ) : (
//         ''
//       )}
//       <div className={styles['margin_left_20']}>
//         <button
//           className={['btn-lg btn-default', styles['margin_zero']].join(' ')}
//           onClick={nextOnClick}
//           value={props.nextText}
//           name={props.nextText}
//         >
//           {props.nextText}
//         </button>
//       </div>
//     </div>
//   )
// }

// export default BackNextButtons

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import styles from './BackNextButtons.module.scss'
import { useHistory } from 'react-router-dom'

const BackNextButtons = ({ props, nextOnClick, errorMsg, displayBack = true }) => {
  const history = useHistory()

  const goBack = (e) => {
    try {
      if (!props.prevURL) {
        e.preventDefault();
        history.goBack();
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className={styles['display_flex']}>

      <div>
        <button
          className={['btn-lg btn-default', styles['margin_zero']].join(' ')}
          onClick={nextOnClick}
          value={props.nextText}
          name={props.nextText}
        >
          {props.nextText}
        </button>
      </div>

      {displayBack ? (
        <div className={[styles['back_center'], styles['margin_left_20']].join(" ")}>
          <a
            onClick={goBack}
            href={props.prevURL}
          >
            {props.prevText}
          </a>
        </div>
      ) : (
        ''
      )}

      {errorMsg && errorMsg !== '' ?
        <span id="date-field-error" className="form-group has-error col-md-12" style={{ display: 'flex', alignItems: 'center' }}>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={'help-block'} style={{ marginLeft: 5 }}>{errorMsg}</div>

        </span> : null
      }
    </div>
  )
}

export default BackNextButtons
